<div class="community-feed-item__button community-feed-item__add-comment-button">
  <a href="#" attr.aria-label="{{ariaLabel}}"
     (click)="navigateAfterCheckingForLightTester()">
    <i class="material-icons" [attr.aria-hidden]="true" [ngClass]="{active: commentable.comments.commented_by_current_user}">comment</i>
    &ngsp;<span class="comment-count" [attr.aria-hidden]="true">{{commentable.comments.count}}</span></a>
</div>
